import axios from 'axios'

export const lessonStatusCode = (error: unknown): number | undefined => {
  if (axios.isAxiosError(error)) {
    return error.response?.status
  }
  return undefined
}

export const lessonErrorMessage = (error: unknown): string | undefined => {
  if (!axios.isAxiosError(error)) {
    return undefined
  }
  const data = error.response?.data
  if (typeof data === 'string') {
    const trimmed = data.trim()
    return trimmed.length > 0 ? trimmed : undefined
  }
  if (!data || typeof data !== 'object' || !('message' in data)) {
    return undefined
  }
  const message = (data as { message: unknown }).message
  if (typeof message === 'string' && message.trim().length > 0) {
    return message
  }
  if (Array.isArray(message)) {
    const text = message.filter((item) => typeof item === 'string').join(' ')
    return text.length > 0 ? text : undefined
  }
  return undefined
}
